import {connect} from 'react-redux';
import {Loader, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {withRouter} from "react-router";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import {getIdFromProps, redirectToOrderStepNumber} from "../../../utils/utils";
import CustomerPage from "../CustomerPage";
import ObjednavkaPotvrzeniRow from "../../../components/ObjednavkaPotvrzeniRow";
import ObjednavkyUrlFactory from "../../../api/ObjednavkyUrlFactory";
import {Link} from "react-router-dom";
import {Button, ButtonToolbar} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka zobrazující se po úspěšném odeslání objednávky.
 */
class ObjednavkaDokoncenaPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(objednavkaActions.fetchObjednavkaIfNeeded(getIdFromProps(this.props)));
    };

    handleNovaObjednavka = () => {
        // v tuhle chvíli uživatel logicky nemůže mít rozpracovanou objednávku - rovnou přesměrujeme na novou
        return redirectToOrderStepNumber(1, this.props);
    };

    handleMojeObjednavky = () => {
        this.props.history.push('/objednavky');
    };

    render() {
        const {objednavkaDetail, t} = this.props;

        if (!objednavkaDetail.fetched) {
            return <Loader/>;
        }

        const objednavka = objednavkaDetail.data;
        const objednalUzivatel = objednavka.uzivatelObjednalId === objednavka.uzivatelZapsalId;
        const text = objednalUzivatel ? t('order.send_success',{orderNumber: objednavka.cisloObjednavka}) : t('order.creation_success', {orderNumber: objednavka.cisloObjednavka});

        return <CustomerPage title={t('pages.main.title')} subtitle={t('order.new')}>
            <ObjednavkaPotvrzeniRow text={text} success={true}/>
            <p className="mt-3 mb-3">
                {objednalUzivatel ? t('order.email_confirmation') : t('order.email_confirmation_customer')}
                {" " + t('order.state_tracking')} <Link to={ObjednavkyUrlFactory.objednavkaDetail(objednavka.id)}>{t('here').toLowerCase()}.</Link>
            </p>
            <ButtonToolbar>
                <Button color="primary" onClick={this.handleMojeObjednavky}>{t('order.own')}</Button>
                <Button color="primary" onClick={this.handleNovaObjednavka}>{t('order.new')}</Button>
            </ButtonToolbar>
        </CustomerPage>
    }
}

function mapStateToProps(state) {
    return {
        objednavkaDetail: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_DETAIL_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(ObjednavkaDokoncenaPage)));

